<template src="./Shared/template.html" />
<script>
import baseScript from './Shared/script'

export default {
  extends: baseScript,
  setup () {
    const { $lang } = useNuxtApp()
    const content = computed(() => {
      return $lang === 'de' ? ['15%', 'OFF NEW', 'COLLECTION', 'CODE: WELOVEYOURGUTS', ''] : ['15%', 'OFF NEW', 'COLLECTION', 'CODE: WELOVEYOURGUTS', '']
    })

    return { content }
  }
}
</script>
<style lang="scss" module>
@use './Shared/style';

.promotion {
  background-image: url('/images/promotions/womens-day/background.webp');
  background-size: 101% 101%;
  border: 2px solid $grey-lighter;
  container: promotion / inline-size;

  &__inner {
    align-items: flex-start;
    justify-content: flex-start;
    padding: 5.25cqw 6cqw;
  }

  &__row {
    line-height: .8;
    -webkit-text-stroke: .5cqw transparent;

    &--0,
    &--2 {
      animation: flash 1s infinite;
    }

    &--0 {
      color: $white;
      font-size: 42cqw;
      margin-top: 2cqw;

    }

    &--1 {
      color: transparent;
      animation: flash 1s infinite;
      animation-delay: .5s;
      font-size: 14.8cqw;
      margin-bottom: .9cqw;
    }

    &--2 {
      color: $white;
      font-size: 14.8cqw;
    }

    &--3 {
      color: $white;
      opacity: .75;
      font-size: 4.5cqw;
      padding: .3cqw 1cqw;
      margin-top: 3.5cqw;
    }

    &--4 {
      position: absolute;
      height: 36.5cqw;
      width: 36.5cqw;
      transform: rotate(15deg);
      right: 3cqw;
      background-image: url('/images/promotions/womens-day/sticker-shadow-2.svg');
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}

@keyframes flash {
  0%, 49.999% {
    -webkit-text-stroke: .5cqw transparent;
    color: $white;
  }

  50%, 99.99% {
    -webkit-text-stroke: .5cqw $white;
    color: transparent;
  }
}
</style>
